import React from 'react';

export const loadComponent = (path) => {
    console.log(`Loading component ${path}`);
    const Component = React.lazy(() =>
        import("../" + path)
    );
    return Component;
};
